// 인플루언서 관련 더미 데이터
// API 스펙: api-spec.yaml의 Influencer 스키마 참조

/**
 * 인플루언서 목록 조회 더미 데이터
 * GET /api/influencers
 */
export const influencersListDummyData = {
  success: true,
  data: [
      {
        id: 'inf-001',
        kolId: 'autumnpearr',
        platforms: [
          {
            id: 'plat-001',
            platformType: 'Instagram',
            profileId: '@autumnpearr',
            profileUrl: 'https://www.instagram.com/autumnpearr',
            followers: 684000,
            grade: 'IG Reels',
            adminNote: '태국 유명 인플루언서'
          },
          {
            id: 'plat-002',
            platformType: 'Tiktok',
            profileId: '@autumnpearr',
            profileUrl: 'https://www.tiktok.com/@autumnpearr',
            followers: 520000,
            grade: 'TT VDO',
            adminNote: ''
          }
        ],
        followers: 684000,
        contentFormat: 'IG Reels',
        country: 'Thailand',
        avgRate: 4.5,  // (5 + 4) / 2 = 4.5
        reviewCount: 2,
        reviews: ['rev-001', 'rev-002'],
        contentOn: true,
        contacts: [
          {
            id: 'contact-001',
            channel: 'LINE',
            contactId: 'autumnpearr_line'
          },
          {
            id: 'contact-002',
            channel: 'EMAIL',
            contactId: 'autumn@example.com'
          }
        ],
        kolSupplyStep: {
          contentId: 'content-001',
          currency: 'THB',
          amount: 50000,
          currentAmount: 50000
        },
        clientTotalFee: {
          managementId: 'mgmt-001',
          contractInfluencerId: 'ci-001',
          currency: 'USD',
          amount: 1800
        },
        createdAt: '2024-01-15T10:30:00Z',
        updatedAt: '2024-03-20T14:22:00Z'
      },
      {
        id: 'inf-002',
        kolId: 'vietnamfoodie',
        platforms: [
          {
            id: 'plat-003',
            platformType: 'Tiktok',
            profileId: '@vietnamfoodie',
            profileUrl: 'https://www.tiktok.com/@vietnamfoodie',
            followers: 1200000,
            grade: 'TT VDO',
            adminNote: '베트남 음식 전문'
          }
        ],
        followers: 1200000,
        contentFormat: 'TT VDO',
        country: 'Vietnam',
        avgRate: 5.0,  // 5 / 1 = 5.0
        reviewCount: 1,
        reviews: ['rev-003'],
        contentOn: true,
        contacts: [
          {
            id: 'contact-003',
            channel: 'WHATSAPP',
            contactId: '+84901234567'
          }
        ],
        kolSupplyStep: {
          contentId: 'content-002',
          currency: 'VND',
          amount: 25000000,
          currentAmount: 25000000
        },
        clientTotalFee: {
          managementId: 'mgmt-002',
          contractInfluencerId: 'ci-002',
          currency: 'USD',
          amount: 1200
        },
        createdAt: '2024-02-10T09:15:00Z',
        updatedAt: '2024-03-18T11:30:00Z'
      },
      {
        id: 'inf-003',
        kolId: 'fashionista_sg',
        platforms: [
          {
            id: 'plat-004',
            platformType: 'Instagram',
            profileId: '@fashionista_sg',
            profileUrl: 'https://www.instagram.com/fashionista_sg',
            followers: 450000,
            grade: 'IG Pics',
            adminNote: '싱가포르 패션 블로거'
          },
          {
            id: 'plat-005',
            platformType: 'X',
            profileId: '@fashionista_sg',
            profileUrl: 'https://twitter.com/fashionista_sg',
            followers: 180000,
            grade: 'X Feed',
            adminNote: ''
          }
        ],
        followers: 450000,
        contentFormat: 'IG Pics',
        country: 'Singapore',
        avgRate: 3.0,  // 3 / 1 = 3.0
        reviewCount: 1,
        reviews: ['rev-004'],
        contentOn: true,
        contacts: [
          {
            id: 'contact-004',
            channel: 'EMAIL',
            contactId: 'fashionista@example.com'
          },
          {
            id: 'contact-005',
            channel: 'INSTAGRAM_DM',
            contactId: '@fashionista_sg'
          }
        ],
        kolSupplyStep: {
          contentId: 'content-003',
          currency: 'SGD',
          amount: 3500,
          currentAmount: 3500
        },
        clientTotalFee: {
          managementId: 'mgmt-003',
          contractInfluencerId: 'ci-003',
          currency: 'USD',
          amount: 2800
        },
        createdAt: '2024-01-20T13:45:00Z',
        updatedAt: '2024-03-21T16:10:00Z'
      },
      {
        id: 'inf-004',
        kolId: 'tech_reviewer_kr',
        platforms: [
          {
            id: 'plat-006',
            platformType: 'Youtube',
            profileId: '@tech_reviewer_kr',
            profileUrl: 'https://www.youtube.com/@tech_reviewer_kr',
            followers: 850000,
            grade: 'YT Exclusive',
            adminNote: '한국 기술 리뷰어'
          }
        ],
        followers: 850000,
        contentFormat: 'YT Exclusive',
        country: 'Korea',
        avgRate: 0.0,  // 0 / 1 = 0.0 (평가 전)
        reviewCount: 1,
        reviews: ['rev-005'],
        contentOn: true,
        contacts: [
          {
            id: 'contact-006',
            channel: 'KAKAO',
            contactId: 'techreviewer'
          },
          {
            id: 'contact-007',
            channel: 'EMAIL',
            contactId: 'tech.reviewer@example.com'
          }
        ],
        kolSupplyStep: {
          contentId: 'content-004',
          currency: 'KRW',
          amount: 5000000,
          currentAmount: 5000000
        },
        clientTotalFee: {
          managementId: 'mgmt-004',
          contractInfluencerId: 'ci-004',
          currency: 'USD',
          amount: 4200
        },
        createdAt: '2024-01-05T08:20:00Z',
        updatedAt: '2024-03-22T10:45:00Z'
      },
      {
        id: 'inf-005',
        kolId: 'beauty_queen_th',
        platforms: [
          {
            id: 'plat-007',
            platformType: 'Instagram',
            profileId: '@beauty_queen_th',
            profileUrl: 'https://www.instagram.com/beauty_queen_th',
            followers: 320000,
            grade: 'IG Reels',
            adminNote: '뷰티 전문'
          },
          {
            id: 'plat-008',
            platformType: 'Tiktok',
            profileId: '@beauty_queen_th',
            profileUrl: 'https://www.tiktok.com/@beauty_queen_th',
            followers: 890000,
            grade: 'TT VDO',
            adminNote: ''
          }
        ],
        followers: 890000,
        contentFormat: 'TT VDO',
        country: 'Thailand',
        avgRate: 2.0,  // 2 / 1 = 2.0
        reviewCount: 1,
        reviews: ['rev-006'],
        contentOn: false,
        contacts: [
          {
            id: 'contact-008',
            channel: 'LINE',
            contactId: 'beautyqueen'
          }
        ],
        kolSupplyStep: {
          contentId: 'content-005',
          currency: 'THB',
          amount: 45000,
          currentAmount: 45000
        },
        clientTotalFee: {
          managementId: 'mgmt-005',
          contractInfluencerId: 'ci-005',
          currency: 'USD',
          amount: 1500
        },
        createdAt: '2024-02-01T11:00:00Z',
        updatedAt: '2024-03-15T13:25:00Z'
      }
  ],
  meta: {
    total: 5,
    totalPages: 1,
    currentPage: 1,
    limit: 20
  }
};

/**
 * 인플루언서 상세 조회 더미 데이터 (InfluencerDetailModal용)
 * GET /api/influencers/{id}
 */
export const influencerDetailDummyData = {
  success: true,
  data: {
    id: 'INF-001',
    representativeName: 'autumnpearr',

    // 기본 정보
    lastName: '홍',
    firstName: '길동',
    fullName: '홍길동',
    country: 'Thailand',
    idNumber: '1234567890123',
    passportNumber: 'P123456',

    // 배송 정보
    recipientName: '홍길동',
    phone: '010-1234-5678',
    address: '서울특별시 서대문구',
    postalCode: '04321',

    // 은행 정보
    bankName: '우리 은행',
    accountNumber: '1002-123-456789',
    bankAddress: '서울시 중구 을지로',

    // 컨택 수단
    contacts: [
      {
        id: 1,
        channel: 'email',
        value: 'autumn@example.com'
      },
      {
        id: 2,
        channel: 'Line',
        value: 'autumn_line'
      }
    ],

    // 운영 채널
    channels: [
      {
        id: 1,
        platform: 'Instagram',
        profileUrl: 'https://www.instagram.com/autumnpearr',
        contentTypes: ['IG Pics', 'IG Reels'],
        followers: 684000,
        memo: 'Instagram 메인 계정'
      },
      {
        id: 2,
        platform: 'Tiktok',
        profileUrl: 'https://www.tiktok.com/@autumnpearr',
        contentTypes: ['TT VDO'],
        followers: 520000,
        memo: 'TikTok 메인 계정'
      },
      {
        id: 3,
        platform: 'Facebook',
        profileUrl: 'https://www.facebook.com/autumnpearr',
        contentTypes: ['FB'],
        followers: 340000,
        memo: 'Facebook 페이지'
      }
    ]
  }
};

/**
 * 인플루언서 생성 더미 응답
 * POST /api/influencers
 */
export const createInfluencerDummyData = {
  success: true,
  data: {
    id: 'inf-new-001',
    kolId: 'new_influencer',
    platforms: [],
    followers: 0,
    contentFormat: '',
    country: 'Vietnam',
    avgRate: 0,
    reviewCount: 0,
    reviews: [],
    contentOn: true,
    contacts: [],
    kolSupplyStep: null,
    clientTotalFee: null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
};

/**
 * CSV 업로드 더미 응답
 * POST /api/influencers/csv-upload
 */
export const csvUploadDummyData = {
  success: true,
  message: 'CSV 파일이 성공적으로 업로드되었습니다.',
  data: {
    totalRows: 6,
    successCount: 6,
    failedCount: 0,
    createdInfluencers: [
      {
        id: 'inf-csv-001',
        kolId: 'jmiefu',
        platformType: 'INSTAGRAM',
        followers: 114000
      },
      {
        id: 'inf-csv-002',
        kolId: 'vickiebeibei',
        platformType: 'INSTAGRAM',
        followers: 161000
      },
      {
        id: 'inf-csv-003',
        kolId: 'nicowonggg',
        platformType: 'INSTAGRAM',
        followers: 46200
      },
      {
        id: 'inf-csv-004',
        kolId: 'cherishlingj',
        platformType: 'INSTAGRAM',
        followers: 28600
      },
      {
        id: 'inf-csv-005',
        kolId: 'luwistann',
        platformType: 'INSTAGRAM',
        followers: 185000
      },
      {
        id: 'inf-csv-006',
        kolId: 'anrettaaa131419',
        platformType: 'INSTAGRAM',
        followers: 79400
      }
    ],
    errors: []
  }
};

/**
 * 운영 상태 일괄 변경 더미 응답
 * PATCH /api/influencers/bulk-update-status
 */
export const bulkUpdateStatusDummyData = {
  success: true,
  data: {
    updatedCount: 3,
    updatedIds: ['inf-001', 'inf-002', 'inf-003'],
    contentOn: true
  }
};

/**
 * 인플루언서 리뷰 목록 더미 데이터
 * GET /api/influencers/{id}/reviews
 */
export const influencerReviewsDummyData = {
  success: true,
  data: {
    reviews: [
      {
        id: 'rev-001',
        influencerId: 'inf-001',
        campaignId: 'camp-001',
        campaignName: 'Spring Beauty Campaign',
        reviewerName: 'Client Manager',
        rating: 5.0,
        comment: '매우 만족스러운 협업이었습니다. 콘텐츠 품질이 우수하고 커뮤니케이션도 원활했습니다.',
        satisfactionEvaluation: {
          contentQuality: 5,
          communication: 5,
          overall: 5
        },
        createdAt: '2024-03-15T14:30:00Z',
        updatedAt: '2024-03-15T14:30:00Z'
      },
      {
        id: 'rev-002',
        influencerId: 'inf-001',
        campaignId: 'camp-005',
        campaignName: 'Summer Fashion',
        reviewerName: 'BLB Manager',
        rating: 4.5,
        comment: '전반적으로 좋았으나 일정이 약간 지연되었습니다.',
        satisfactionEvaluation: {
          contentQuality: 5,
          communication: 4,
          overall: 4
        },
        createdAt: '2024-02-20T10:15:00Z',
        updatedAt: '2024-02-20T10:15:00Z'
      },
      {
        id: 'rev-003',
        influencerId: 'inf-002',
        campaignId: 'camp-010',
        campaignName: 'Vietnam Food Festival',
        reviewerName: 'BLB Manager',
        rating: 4.8,
        comment: '음식 관련 콘텐츠가 매우 전문적이었습니다. 팔로워 반응도 좋았습니다.',
        satisfactionEvaluation: {
          contentQuality: 5,
          communication: 5,
          overall: 5
        },
        createdAt: '2024-03-10T09:20:00Z',
        updatedAt: '2024-03-10T09:20:00Z'
      },
      {
        id: 'rev-004',
        influencerId: 'inf-003',
        campaignId: 'camp-015',
        campaignName: 'Singapore Fashion Week',
        reviewerName: 'Client Manager',
        rating: 3.5,
        comment: '콘텐츠는 좋았으나 업로드 일정이 지연되었습니다.',
        satisfactionEvaluation: {
          contentQuality: 4,
          communication: 3,
          overall: 3
        },
        createdAt: '2024-02-28T15:45:00Z',
        updatedAt: '2024-02-28T15:45:00Z'
      },
      {
        id: 'rev-005',
        influencerId: 'inf-004',
        campaignId: 'camp-020',
        campaignName: 'Tech Product Review',
        reviewerName: 'Client Manager',
        rating: 0,
        comment: '아직 평가 전',
        satisfactionEvaluation: {
          contentQuality: 0,
          communication: 0,
          overall: 0
        },
        createdAt: '2024-03-25T11:00:00Z',
        updatedAt: '2024-03-25T11:00:00Z'
      },
      {
        id: 'rev-006',
        influencerId: 'inf-005',
        campaignId: 'camp-025',
        campaignName: 'Beauty Campaign Thailand',
        reviewerName: 'BLB Manager',
        rating: 2.0,
        comment: '콘텐츠 품질은 괜찮았으나 커뮤니케이션이 원활하지 않았고, 일정 준수가 되지 않았습니다.',
        satisfactionEvaluation: {
          contentQuality: 3,
          communication: 1,
          overall: 2
        },
        createdAt: '2024-03-18T16:20:00Z',
        updatedAt: '2024-03-18T16:20:00Z'
      }
    ],
    pagination: {
      total: 6,
      totalPages: 1,
      currentPage: 1,
      limit: 10
    }
  }
};

/**
 * 인플루언서 수정 더미 응답
 * PATCH /api/influencers/{id}
 */
export const updateInfluencerDummyData = {
  success: true,
  message: '인플루언서가 성공적으로 수정되었습니다.'
};

/**
 * 인플루언서 삭제 더미 응답
 * DELETE /api/influencers/{id}
 */
export const deleteInfluencerDummyData = {
  success: true,
  message: '인플루언서가 성공적으로 삭제되었습니다.'
};

/**
 * 팔로워 수 수정 더미 응답
 * PATCH /api/influencers/{id}/followers
 */
export const updateFollowersDummyData = {
  success: true,
  data: {
    id: 'inf-001',
    followers: 700000
  }
};

/**
 * 연락처 수정 더미 응답
 * PATCH /api/influencers/{id}/contacts/{contactId}
 */
export const updateContactDummyData = {
  success: true,
  data: {
    id: 'contact-001',
    channel: 'EMAIL',
    contactId: 'updated@example.com'
  }
};

/**
 * KOL Supply Step 수정 더미 응답
 * PATCH /api/influencers/{id}/kol-supply-step
 */
export const updateKolSupplyStepDummyData = {
  success: true,
  data: {
    contentId: 'content-001',
    currency: 'USD',
    amount: 1500
  }
};

/**
 * Client Total Fee 수정 더미 응답
 * PATCH /api/influencers/{id}/client-total-fee
 */
export const updateClientTotalFeeDummyData = {
  success: true,
  data: {
    managementId: 'mgmt-001',
    currency: 'USD',
    amount: 2000
  }
};

// ============================================
// 통합 API용 Export
// ============================================

/**
 * 인플루언서 상세 정보를 ID별로 관리
 * GET /api/influencers/{id}
 */
export const influencerDetailDataById = {
  'inf-001': {
    success: true,
    data: {
      id: 'inf-001',
      representativeName: 'autumnpearr',
      lastName: '홍',
      firstName: '길동',
      fullName: '홍길동',
      country: 'Thailand',
      idNumber: '1234567890123',
      passportNumber: 'P123456',
      recipientName: '홍길동',
      phone: '010-1234-5678',
      address: '서울특별시 서대문구',
      postalCode: '04321',
      bankName: '우리 은행',
      accountNumber: '1002-123-456789',
      bankAddress: '서울시 중구 을지로',
      contacts: [
        {
          id: 1,
          channel: 'email',
          value: 'autumn@example.com'
        },
        {
          id: 2,
          channel: 'Line',
          value: 'autumn_line'
        }
      ],
      channels: [
        {
          id: 1,
          platform: 'Instagram',
          profileUrl: 'https://www.instagram.com/autumnpearr',
          contentTypes: ['IG Pics', 'IG Reels'],
          followers: 684000,
          memo: 'Instagram 메인 계정'
        },
        {
          id: 2,
          platform: 'Tiktok',
          profileUrl: 'https://www.tiktok.com/@autumnpearr',
          contentTypes: ['TT VDO'],
          followers: 520000,
          memo: 'TikTok 메인 계정'
        },
        {
          id: 3,
          platform: 'Facebook',
          profileUrl: 'https://www.facebook.com/autumnpearr',
          contentTypes: ['FB'],
          followers: 340000,
          memo: 'Facebook 페이지'
        }
      ]
    }
  },
  'inf-002': {
    success: true,
    data: {
      id: 'inf-002',
      representativeName: 'vietnamfoodie',
      lastName: 'Nguyen',
      firstName: 'Van A',
      fullName: 'Nguyen Van A',
      country: 'Vietnam',
      idNumber: '0987654321',
      passportNumber: 'V987654',
      recipientName: 'Nguyen Van A',
      phone: '+84901234567',
      address: 'Ho Chi Minh City',
      postalCode: '700000',
      bankName: 'Vietcombank',
      accountNumber: '1234567890',
      bankAddress: 'HCMC Branch',
      contacts: [
        {
          id: 1,
          channel: 'WHATSAPP',
          value: '+84901234567'
        }
      ],
      channels: [
        {
          id: 1,
          platform: 'Tiktok',
          profileUrl: 'https://www.tiktok.com/@vietnamfoodie',
          contentTypes: ['TT VDO'],
          followers: 1200000,
          memo: 'TikTok 메인 계정'
        }
      ]
    }
  }
};

// ID로 인플루언서 상세 정보 가져오기 헬퍼 함수
export const getInfluencerDetailById = (id) => {
  return influencerDetailDataById[id] || null;
};

/**
 * 인플루언서 배송지 주소 조회 더미 데이터
 * GET /api/influencers/{influencerId}/shipping-address
 */
export const getInfluencerShippingAddressDummyData = {
  'inf-001': {
    success: true,
    data: {
      recipientName: '홍길동',
      phone: '010-1234-5678',
      address: '서울특별시 서대문구',
      postalCode: '04321'
    }
  },
  'inf-002': {
    success: true,
    data: {
      recipientName: 'Nguyen Van A',
      phone: '+84901234567',
      address: 'Ho Chi Minh City',
      postalCode: '700000'
    }
  }
};

/**
 * 인플루언서 배송지 주소 업데이트 더미 데이터
 * PUT /api/influencers/{influencerId}/shipping-address
 */
export const updateInfluencerShippingAddressDummyData = {
  success: true,
  message: '배송지 주소가 업데이트되었습니다.'
};
